<!-- 学生考勤 -->
<template>
	<div class="fuzzy-matching-box">
		<!-- 学生考勤 -->
		<div class="fuzzy-matching-top">
			<el-row class="top-first-line the-second-line">
				<el-col :span="5" v-if="teacherObj.schoolId == '' ||teacherObj.schoolId == null">
					<el-form-item label="学校:">
						<el-select v-model="Dform.schoolId" placeholder="请选择学校" @change="schoolClickTop">
							<el-option :label="item.name" :value="item.id" v-for="item in schoolList"
								:key="item.name"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="5" v-if=" teacherObj.gradeId == '' ||teacherObj.gradeId == null">
					<el-form-item label="年级:">
						<el-select v-model="Dform.GradeId" placeholder="请选择年级" @change="GradeTop">
							<el-option :label="item.name" :value="item.id" v-for="item in gradeDataList"
								:key="item.name"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="班级:">
						<el-select v-model="Dform.classId" placeholder="请选择班级" @change="ClassTop">
							<el-option :label="item.name" :value="item.id" v-for="item in classList"
								:key="item.name"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="4">
					<el-form-item label="月份:">
						<el-date-picker v-model="Dform.value2" type="month" value-format="YYYY-MM"
							@change="handleMonthChange" placeholder="选择月" :disabled-date="disabledDate">
						</el-date-picker>
					</el-form-item>
				</el-col>
				<el-button type="primary" class="query-button" @click="entrylogClick">查询</el-button>
				<div class="Prompt ">
					<div class="present" style="background-color: #15C377;" @click="LookBtn">全勤</div>
					<div class="present" style="background-color: #1296db;" @click="LookBtn">出勤</div>
					<div class="present" style="background-color: #F96868;" @click="LookBtn">缺勤</div>
				</div>
			</el-row>
		</div>
		<div class="fuzzy-matching-bottom">
			<el-row class="list">
				<el-table stripe :border="true" v-loading="loading"
					:header-cell-style="{ background: '#EDF6FF', color: '#000', }" ref="multipleTable" :data="tableData"
					tooltip-effect="dark" style="width: 100%" height="60vh" @selection-change="handleSelectionChange">
					<el-table-column prop="" label="姓名/日期">
						<template #default="scope">
							{{scope.row.studentName}}
						</template>
					</el-table-column>
					<el-table-column v-for="(column, Itemindex) in columns" :key="column.prop" :prop="column.prop"
						:label="column.label" :formatter="column.formatter">
						<template #header>
							<div>{{ column.name }}</div>
							<div>{{ column.days }}</div>
						</template>
						<template #default="scope">
							<span class="yuanhe_box">
								<span v-for="(sitem, ins) in scope.row.attendanceList" v-if="scope.row.attendanceList.length">
									<span class="yangshi_box"><span class="yuan_box"></span></span>
									<span v-if="sitem.time == column.time" :class="[
											sitem.attendanceStatus == 0 ? 'yangshi_box' : '', 
											sitem.attendanceStatus == 1 ? 'yangshi_box_lan' : '', 
											sitem.attendanceStatus == 2 ? 'yangshi_box_lv' : '']">
										<span class="yuan_box"></span>
									</span>
								</span>
								<span v-else class="yangshi_box"><span class="yuan_box"></span></span>
							</span>
							<!-- <span v-else class="yangshi_box"><span class="yuan_box"></span></span> -->
						</template>
					</el-table-column>
				</el-table>


			</el-row>
		</div>
		<Index v-if="ShowIndex" @closeBtn="closeBtn"></Index>
	</div>
</template>
<script>
	import {
		MonthAttendanceList,
	} from '@/assets/api/schoollog.js'
	import {
		school,
		findTeacherInfo,
		gradeList,
		findClassList
	} from '@/assets/api/renyuan';
	import Index from './msg/index.vue'
	export default {
		components: {
			Index
		},
		data() {
			return {
				loading: true,
				Dform: {
					classId: "",
					GradeId: "",
					schoolId: "",
					value2: '',
				},
				tableData: [],
				columns: [],
				pageValue: 1,
				schoolList: [],
				gradeDataList: [],
				classList: [],
				teacherObj: {},
				ShowIndex: false,
			};
		},
		created() {
			this.getLastTenDays();
			this.schoolPost()
			this.Lookteacher()
		},
		mounted() {
			this.MonthAttendanceList()
		},
		methods: {
			LookBtn() {
				this.ShowIndex = true
			},
			closeBtn() {
				this.ShowIndex = false

			},
			handleCurrentChange() {
				console.log(val, '分页');
				this.pageValue = val
			},
			
			disabledDate(time) {
			  const now = new Date();
			  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
			  const selectedDay = new Date(time.getFullYear(), time.getMonth(), time.getDate(), 0, 0, 0);
			  return selectedDay.getTime() > today.getTime();
			},
			
			handleMonthChange(value) {
			  console.log('Selected month:', value);
			},

			getLastTenDays() {
				const daysxingqi = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
				let selected = new Date(this.Dform.value2); //选中的日期
				let today = new Date(); // 获取今天的日期
				if(this.Dform.value2 != "" && selected.getMonth() != today.getMonth()){
					if(selected < today){
						const [year, month] = this.Dform.value2.split('-');
						today = new Date(`${year}-${month}-${new Date(year, parseInt(month), 0).getDate()}`)
					}
				}

				const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1); // 获取当前月的第一天

				let days = []; // 用于存储每一天的日期
				this.columns = [];
				let currentDate = new Date(firstDayOfMonth); // 从第一天的日期开始
				while (currentDate <= today) {
					days.push(new Date(currentDate)); // 将每一天的日期添加到数组中
					currentDate.setDate(currentDate.getDate() + 1); // 增加一天
				}

				days.forEach((res) => {
					let yyyy = res.getFullYear().toString();
					let MM = (res.getMonth() + 1).toString().padStart(2, '0');
					let dd = res.getDate().toString().padStart(2, '0');
					console.log(yyyy + MM + dd);
					this.columns.push({
						name: dd,
						days: daysxingqi[res.getDay()],
						time: yyyy + MM + dd,
						value: '',
						studentName: '',
					})
				})
				console.log(this.columns, '天数11'); // 返回包含所有日期的数组
			},
			
			entrylogClick() {
				this.getLastTenDays();
				this.MonthAttendanceList()
			},
			
			MonthAttendanceList() {
				let params = {
					classId: this.Dform.classId,
					time: this.Dform.value2,
				}
				MonthAttendanceList(params).then((res) => {
					console.log(res, '反参');
					this.tableData = res.data.data
					this.loading = false
					this.tableData.forEach((item) => {
						item.attendanceList.forEach((item2) => {
							this.columns.forEach((item3) => {
								item3.value = item2.attendanceStatus

								if (item2.time == item3.time) {
									item3.value = item2.attendanceStatus
								}
							})
						})
					})

					console.log(this.columns, 111111);
				}).catch((err) => {
					this.$message({
						type: 'error',
						message: err.response.data.msg || '接口异常'
					});
				})
			},
			//查看身份
			Lookteacher() {
				let params = {
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				findTeacherInfo(params).then((res) => {
					this.teacherObj = res.data.data
					if (this.teacherObj.gradeId || this.teacherObj.classId) {
						this.classClick(this.teacherObj.gradeId)
					} else if (this.teacherObj.schoolId) {
						this.GradeClick(this.teacherObj.schoolId)
					}
				}).catch((err) => {
					console.log(err);
				})

			},
			// 学校
			schoolPost() {
				let params = {
					page: '1',
					pageSize: '999',
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				school(params).then((res) => {
					// console.log(res,'学校列表');
					this.schoolList = res.data.data.list

				}).catch((err) => {
					console.log(err);
				})
			},
			// 年级
			GradeClick(val) {
				let params = {
					page: '1',
					pageSize: '999',
				}
				gradeList(params, val).then((res) => {
					this.gradeDataList = res.data.data;
					// console.log(res,'年级列');
				}).catch((err) => {
					console.log(err);
				})
			},
			// 班级
			classClick(val) {
				let params = {
					page: '1',
					pageSize: '999',
				}
				findClassList(params, val).then((res) => {
					console.log(res, '班级列表');
					this.classList = res.data.data;
				}).catch((err) => {
					console.log(err);
				})
			},
			schoolClickTop() {
				this.Dform.GradeId = ''
				this.Dform.classId = ''
				this.GradeClick(this.Dform.schoolId)
			},
			GradeTop() {
				this.teacherObj.classId = ''
				this.classClick(this.Dform.GradeId)
			},
			ClassTop() {
				// this.MonthAttendanceList()
			}

		},
	};
</script>

<style scoped lang="scss">
	.fuzzy-matching-box {
		padding-top: 40px;
		width: 100%;
		height: 96%;
		background-color: #fff;
		border-radius: 8px;

		.fuzzy-matching-top {
			height: 80px;
			background-color: #fff;
			border-radius: 8px;

			.top-first-line {
				:deep() {
					.el-form-item--small .el-form-item__label {
						font-size: 16px;
					}

					.el-select--small {
						width: 100%
					}

					.el-form-item--small .el-form-item__label {
						width: 110px;
						text-align: right;
						height: 35px;
						line-height: 35px;
						font-weight: 700;
					}

					.el-input {
						width: 100%;
						height: 35px;
					}

					.el-select--small .el-select__wrapper {
						height: 35px !important;
					}
				}
			}

			.query-button {
				width: 55px;
				height: 30px;
				margin-left: 50px;
			}

			.Prompt {
				width: 150px;
				// background-color: pink;
				height: 30px;
				margin-left: 20px;
				display: flex;

				.present {
					text-align: center;
					width: 50px;
					line-height: 17px;
					color: #fff;
					margin: 5px;
					border-radius: 5px;
				}
			}


		}

		.fuzzy-matching-content {
			height: 20px;
			line-height: 20px;
			margin-bottom: 10px;

			:deep() {
				.el-button {
					margin-left: 50px;
					font-size: 16px;

				}
			}
		}

		.fuzzy-matching-bottom {
			// position: absolute;
			padding: 20px;

			:deep() {
				.el-table th.el-table__cell>.cell {
					height: 30px;
					line-height: 30px;
					text-align: center;
					font-size: 16px;
				}

				.el-table td.el-table__cell div {
					text-align: center;
					height: 40px;
					line-height: 40px;
					border: 0;
					font-size: 16px;
					color: black;
				}


			}

			.block-fenye {
				margin-left: 1000px;
				margin-top: 15px;
			}

			.yuanhe_box {
				display: inline-block;
				position: relative;
				height: 100%;
				width: 100%;
			}

			.yangshi_box {
				width: 100%;
				display: inline-block;
				height: 100%;
				background-color: #F96868;
				line-height: 45px;
			}

			.yangshi_box_lan {
				position: absolute;
				width: 100%;
				display: inline-block;
				height: 100%;
				background-color: #1296db;
				line-height: 45px;
				top: 0px;
				left: 0px
			}

			.yangshi_box_lv {
				position: absolute;
				width: 100%;
				display: inline-block;
				height: 100%;
				background-color: #15C377;
				line-height: 45px;
				top: 0px;
				left: 0px
			}

			.yuan_box {
				display: inline-block;
				width: 20px;
				height: 20px;
				border-radius: 50%;
				background-color: #fff;
			}
		}


	}

	:deep(.el-table th.el-table__cell>.cell) {
		height: 55px !important;
		line-height: 26px !important // background-color: saddlebrown
	}

	:deep(.el-table thead th:nth-of-type(1).el-table__cell>.cell) {
		height: 55px !important;
		line-height: 55px !important;
	}

	:deep() {
		.el-table--small .cell {
			padding: 0px
		}

		.el-table--small .el-table__cell {
			padding: 0px;
		}
	}
</style>